import React from "react";
import "./header.css";
import CTA from "./CTA";
// import Me from "../../Assets/page-pic.png";
import HeaderSocials from "./HeaderSocials";

function Header() {
  return (
    <header id="home">
      <div className="container header__container">
        <h5>Hello I'm</h5>
        <h1>
          Mohd <span className="tracking-in-expand">Amaan Siddiqui</span>{" "}
        </h1>
        <h5 className="text-light"> Frontend Developer</h5>
        <CTA />
        <HeaderSocials />

        <div class="card me">
          <div class="circle__2"></div>
          <div class="circle__2"></div>
          <div class="card-inner">
            <img src="/Assets/page-pic.png" alt="img"></img>
          </div>
        </div>

        <a href="#footer" className="Scroll__down">
          Scroll Down
        </a>
      </div>
    </header>
  );
}

export default Header;
